import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import html2canvas from 'html2canvas'; // Import html2canvas
import jsPDF from 'jspdf'; // Import jsPDF
import { BASE_URL } from '../config/constants';

function Certificate() {
	const { id } = useParams(); // Extract the `id` from the URL
	const user = JSON.parse(localStorage.getItem('userData')); // Get user data from localStorage
	const [course, setCourse] = useState(null); // Store course details
	const [loading, setLoading] = useState(true); // Track loading state
	const certificateRef = useRef(null); // Ref for the certificate div
	const baseUrl = BASE_URL;
	// Fetch course details
	useEffect(() => {
		const fetchCourseDetails = async () => {
			try {
				const response = await fetch(`${baseUrl}/api/v1/courses/${id}`, {
					method: 'GET',
				});

				if (response.ok) {
					const data = await response.json();
					setCourse(data); // Set course details
				} else {
					console.error('Failed to fetch course details');
				}
			} catch (error) {
				console.error('Error fetching course details:', error);
			} finally {
				setLoading(false); // Set loading to false
			}
		};

		fetchCourseDetails();
	}, [id]);

	// Function to handle downloading the certificate as PDF
	const handleDownload = () => {
		html2canvas(certificateRef.current).then((canvas) => {
			const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data
			const pdf = new jsPDF('landscape', 'mm', 'a4'); // Create a PDF in landscape mode (A4 size)
			const imgWidth = 297; // A4 width in mm
			const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate height to maintain aspect ratio

			// Add the image to the PDF
			pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

			// Download the PDF
			pdf.save('certificate.pdf');
		});
	};

	// Display loading state
	if (loading) {
		return (
			<div className='h-[80vh] flex justify-center items-center text-xl md:text-4xl text-main'>
				Loading...
			</div>
		);
	}

	// Display error if no course is found
	if (!course) {
		return (
			<div className='h-[80vh] flex justify-center items-center text-xl md:text-4xl text-main'>
				No course found.
			</div>
		);
	}

	return (
		<div className='p-6 flex flex-col justify-center items-center h-screen'>
			<div
				ref={certificateRef}
				className='p-6 flex justify-center items-center relative'
				style={{
					width: '800px',
					height: '550px',
				}}>
				<img
					src={'/mages/Cream Bordered Appreciation Certificate.png'}
					alt='Certificate Background'
					className='absolute inset-0 w-full h-full object-cover'
				/>
				<div className='text-center bg-white bg-opacity-90 p-8 -top-16 relative z-10'>
					<h1 className='text-2xl font-bold mb-4'>Certificate of Completion</h1>
					<p className='text-lg'>
						This certifies that{' '}
						<strong>
							{user.firstName} {user.lastName}
						</strong>{' '}
						has successfully completed the course:
					</p>
					<h2 className='text-xl font-semibold mt-4'>{course.name}</h2>
					<p className='text-lg mt-2'>
						<strong>Course Description:</strong> {course.description}
					</p>
					<p className='text-lg mt-2'>
						<strong>Completion Date:</strong> {new Date().toLocaleDateString()}
					</p>
					<p className='text-lg mt-2'>
						<strong>Certificate ID:</strong> xxx
						{Math.random().toString().slice(2, 14)}
					</p>
				</div>
			</div>
			<button
				onClick={handleDownload}
				className='mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg'>
				Download Certificate as PDF
			</button>
		</div>
	);
}

export default Certificate;
